import apiConfig from 'src/integration/config/apiConfig';
import useQueryKey from 'src/toolkit/utils/useQueryKey';
import { useStore } from 'src/integration/store/store';
import useReactQueryJava from 'src/integration/api/useReactQueryJava';
import { MIN_15 } from 'src/integration/config/constants';
import useErrorHandling from 'src/toolkit/utils/useErrorHandling';

const useFetchChartFrequencyAndBalancing = () => {
  const { frequencyAndBalancingStore, settingsStore } = useStore();
  const { setFrequencyAndBalancingData } = frequencyAndBalancingStore;
  const { selectedSiteId, selectedDate } = settingsStore;
  const { logoutOnError } = useErrorHandling();

  const response = useReactQueryJava<SimpleObject, SimpleObject>({
    endpoint: apiConfig.api.endpointsJava.frequencyAndBalancing,
    queryKey: useQueryKey('frequencyAndBalancing', [selectedDate, selectedSiteId?.toString()]),
    method: 'GET',
    queryParams: {
      date: selectedDate,
      siteId: selectedSiteId,
    },
    opts: {
      enabled: !!selectedSiteId,
      refetchOnWindowFocus: false,
      refetchInterval: MIN_15,
      onSuccess: (data: any[]) => {
        setFrequencyAndBalancingData(data);
      },
    },
  });

  return {
    ...response,
  };
};

export default useFetchChartFrequencyAndBalancing;
